/* Pensum — theme scripts */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- Reveal */

  var observer = null;

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-animate]:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
        /* Frueher ausloesen, statt zu warten, bis der Abschnitt schon im
           Bild steht. Vorher: rootMargin '0px 0px -8% 0px' und threshold 0.08
           — ein Abschnitt begann erst zu erscheinen, wenn er bereits 8 % im
           Bild war, und brauchte dann eine volle Sekunde. Beim Scrollen sah
           man ihm dabei zu, und das wirkte wie eine Seite, die noch laedt.
           Jetzt zaehlt der Bereich eine Vierteldbildschirmhoehe unter der
           Falz mit: der Abschnitt ist fertig eingeblendet, bevor das Auge ihn
           erreicht. threshold 0, damit auch Abschnitte ausloesen, die hoeher
           sind als der Bildschirm. */
      }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    }

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------------- Toast */

  var toastTimer = null;

  function toastSchliessen() {
    var toast = document.getElementById('Toast');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.remove('is-visible');
    setTimeout(function () {
      toast.hidden = true;
      toast.classList.remove('toast--wege');
      var wege = toast.querySelector('[data-toast-wege]');
      var zu = toast.querySelector('[data-toast-close]');
      if (wege) wege.hidden = true;
      if (zu) zu.hidden = true;
    }, 400);
  }

  /* Zweites Argument seit dem 05.09.2026: BLEIBT der Kasten stehen?
     Bei einer Meldung (Fehler, "Link kopiert") nicht — sie soll nicht im Weg
     liegen. Nach einem erfolgreichen Hinzufuegen schon, denn sie ist dann der
     einzige sichtbare Weg zur Kasse. */
  function showToast(message, mitWegen) {
    var toast = document.getElementById('Toast');
    if (!toast) return;
    var text = toast.querySelector('[data-toast-text]');
    var wege = toast.querySelector('[data-toast-wege]');
    var zu = toast.querySelector('[data-toast-close]');
    if (text) text.textContent = message;

    if (wege) wege.hidden = !mitWegen;
    if (zu) zu.hidden = !mitWegen;
    toast.classList.toggle('toast--wege', Boolean(mitWegen));

    toast.hidden = false;
    /* Kein requestAnimationFrame allein: In einem Hintergrund-Tab und in
       manchen In-App-Browsern laeuft er nicht, und der Kasten bliebe dann
       durchsichtig stehen — sichtbar fuer niemanden, aber im Weg. */
    window.requestAnimationFrame(function () { toast.classList.add('is-visible'); toastAusweichen(); });
    setTimeout(function () { toast.classList.add('is-visible'); toastAusweichen(); }, 60);

    clearTimeout(toastTimer);
    if (!mitWegen) toastTimer = setTimeout(toastSchliessen, 4200);
  }

  /* DER KASTEN TRITT ZURUECK, WENN EIN BEDIENELEMENT UNTER IHM LIEGT.

     Gefunden bei der Schlusspruefung am 05.09.2026, und es war ein Fehler von
     heute Nachmittag: Der Kasten bleibt stehen, bis der Kunde ihn schliesst —
     das ist gewollt, denn er ist der Weg zur Kasse. Er liegt aber fest am
     unteren Rand, und wer nach dem Hinzufuegen wieder nach oben scrollt, hat
     dort die acht Farbfelder. Gemessen bei 375 x 812, Scrollstand 0: Kasten
     y 694-812, Farbfelder y 677-777. elementsFromPoint auf die Mitte JEDES
     der acht Felder lieferte kein einziges Mal das Farbfeld — sechsmal den
     Kastenkoerper (der Tipp verpufft), bei Beige und Weiss den Knopf
     "Zur Kasse" (der Tipp springt in die Kasse). Dasselbe traf Mengenschalter,
     Kaufknopf, Schriftkacheln und die Verweise in der Fusszeile.

     Dieselbe Regel, die die mitlaufende Kaufleiste seit dem 04.09. befolgt,
     gilt jetzt auch hier: Liegt ein Bedienelement im Band des Kastens, tritt
     er zurueck. Sobald der Kunde weiterscrollt, ist er wieder da. Er
     verschwindet also nicht — er weicht aus. */
  function toastAusweichen() {
    var toast = document.getElementById('Toast');
    if (!toast || toast.hidden || !toast.classList.contains('toast--wege')) return;

    var liste = document.querySelectorAll(
      '.swatch, .pz__input, .pz__font, .pz__ink, .pz__symbol-option,' +
      ' .pz__more-toggle, .pz__clear, .pz__reset, .pz__layer,' +
      ' .quantity__button, .quantity__input, [data-add-button],' +
      ' .footer__link, .cart-item__remove');

    var r = toast.getBoundingClientRect();
    if (!r.height) return;

    // Zugabe, sobald der Kasten schon zurueckgetreten ist — sonst schnappt er
    // genau an der Grenze im Bildtakt auf und zu. Dieselbe Ueberlegung wie bei
    // der Kaufleiste.
    var zugabe = toast.classList.contains('is-zurueck') ? 14 : 0;
    var bandOben = r.top - zugabe;

    var stoert = false;
    for (var i = 0; i < liste.length; i++) {
      var e = liste[i].getBoundingClientRect();
      if (!e.width || !e.height) continue;
      if (e.bottom > bandOben && e.top < window.innerHeight) { stoert = true; break; }
    }
    toast.classList.toggle('is-zurueck', stoert);
  }

  function initToast() {
    var toast = document.getElementById('Toast');
    if (!toast) return;
    var zu = toast.querySelector('[data-toast-close]');
    if (zu) zu.addEventListener('click', toastSchliessen);

    window.addEventListener('scroll', toastAusweichen, { passive: true });
    window.addEventListener('resize', toastAusweichen);
    /* Wer auf einen der beiden Wege tippt, verlaesst die Seite ohnehin —
       aber bei einem geoeffneten neuen Tab oder einem abgebrochenen Sprung
       soll der Kasten nicht ewig stehen bleiben. */
    toast.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { clearTimeout(toastTimer); });
    });
  }

  /* ------------------------------------------------------------ Cart count */

  function refreshCartCount() {
    return fetch(window.Theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { /* silent */ });
  }

  /* ----------------------------------------------------------- Mobile menu */

  function initDrawer() {
    function drawer() { return document.getElementById('MenuDrawer'); }
    function knopf() { return document.querySelector('[data-menu-toggle]'); }

    /* Der Kopfbereich liegt bei offener Schublade über ihr — anders wäre das
       X verdeckt und nicht anklickbar. Damit er dabei nicht die oberste Zeile
       der Schublade zudeckt, braucht die Schublade seinen Platz als Abstand.

       Gemessen statt geraten: Die Höhe hängt an Logogröße und Schriftgrad,
       beides ist im Theme-Editor einstellbar. */
    function kopfhoeheMerken() {
      var kopf = document.querySelector('.header');
      if (!kopf) return;
      var h = Math.round(kopf.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--kopf-hoehe', h + 'px');
    }

    kopfhoeheMerken();
    window.addEventListener('resize', kopfhoeheMerken, { passive: true });

    /* aria-expanded steuert nicht nur die Vorlesesoftware, sondern auch die
       Faltung des Burgers zum X — die CSS-Regel hängt daran. Ein eigener
       Zustand daneben könnte auseinanderlaufen. */
    function setzen(offen) {
      var el = drawer();
      var k = knopf();
      if (offen) kopfhoeheMerken();
      if (el) el.classList.toggle('is-open', offen);
      if (k) k.setAttribute('aria-expanded', offen ? 'true' : 'false');
      document.body.classList.toggle('menu-offen', offen);
      document.body.style.overflow = offen ? 'hidden' : '';
    }

    function close() { setzen(false); }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-menu-toggle]')) {
        event.preventDefault();
        var el = drawer();
        if (!el) return;
        var offen = el.classList.contains('is-open');
        setzen(!offen);
        if (!offen) {
          /* Der Fokus gehört in den Dialog, sonst tastet man sich hinter der
             offenen Schublade weiter. Er liegt aber auf der Schublade selbst,
             nicht auf dem ersten Link — sonst umrahmt ihn der Fokusrahmen in
             der Akzentfarbe, und das sah aus wie eine ausgewählte Zeile. */
          var panel = el.querySelector('.drawer__panel');
          if (panel) {
            panel.setAttribute('tabindex', '-1');
            panel.focus({ preventScroll: true });
          }
        } else {
          var k = knopf();
          if (k) k.focus();
        }
      } else if (event.target.closest('[data-menu-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* ---------------------------------------------------------- Search modal */

  function initSearch() {
    function modal() { return document.getElementById('SearchModal'); }

    function close() {
      var el = modal();
      if (el) el.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-open]')) {
        event.preventDefault();
        var el = modal();
        if (!el) return;
        el.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var input = el.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 60);
      } else if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  /* ------------------------------------------------------- Quantity widget */

  function initQuantity() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-qty-change]');
      if (!button) return;
      event.preventDefault();
      var wrap = button.closest('.quantity');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      var step = button.dataset.qtyChange === 'up' ? 1 : -1;
      var min = parseInt(input.min || '1', 10);
      var next = (parseInt(input.value, 10) || min) + step;
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------------------------------------------------- Produktbilder */

  function initGallery(scope) {
    var roots = (scope || document).querySelectorAll('[data-gallery]');

    roots.forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var main = root.querySelector('[data-gallery-main]');
      if (!main) return;

      var lead = root.querySelector('[data-gallery-lead]');
      var track = root.querySelector('[data-gallery-track]');
      var navButtons = root.querySelectorAll('[data-gallery-scroll]');

      // Die Bilder der Farbvarianten stehen in keiner Kachel. Ihre Quellen
      // liefert das Liquid als JSON mit, damit der Farbwechsel das große Bild
      // trotzdem austauschen kann.
      var sources = {};
      var sourceData = root.querySelector('[data-gallery-sources]');
      if (sourceData) {
        try {
          sources = JSON.parse(sourceData.textContent) || {};
        } catch (fehler) {
          sources = {};
        }
      }

      // Die Kacheln bleiben, wo sie sind — getauscht wird nichts mehr, nur das
      // große Bild oben ausgewechselt. Dadurch springt die Reihe beim
      // Farbwechsel nicht und der Kunde behält seine Orientierung.
      function show(id, src, srcset, alt, sofortBild) {
        if (!src || !lead) return;
        if (lead.dataset.mediaId === String(id)) return;

        /* SOFORT ETWAS ZEIGEN.

           Ohne das steht beim Antippen weiter das ALTE Bild, bis das neue
           geladen ist — auf dem Handy rund eine Sekunde, in der sichtbar
           nichts passiert. Der Inhaber am 06.09.2026: "auf dem handy dauert
           es immer noch ungefaehr eine sekunde mit dem oeffnen der bilder."

           Das Kachelbild liegt bereits im Zwischenspeicher (die Reihe hat es
           geladen). Als Hintergrund der Buehne erscheint es ohne jede neue
           Anfrage, also im selben Wimpernschlag. Es ist klein und deshalb
           weich — aber es ist das RICHTIGE Bild, und sobald die grosse
           Fassung da ist, deckt sie es zu. */
        if (sofortBild) {
          lead.style.backgroundImage = 'url("' + sofortBild + '")';
          main.style.opacity = '0';
          var fertig = function () {
            main.style.opacity = '';
            lead.style.backgroundImage = '';
            main.removeEventListener('load', fertig);
          };
          main.addEventListener('load', fertig);
          /* Liegt die grosse Fassung schon im Zwischenspeicher, faellt das
             load-Ereignis unter Umstaenden aus. Dann sofort aufraeumen. */
          setTimeout(function () { if (main.complete) fertig(); }, 0);
        }

        /* REIHENFOLGE IST ENTSCHEIDEND: erst srcset, dann src.

           Vorher stand src zuerst. Eine Zuweisung an src startet den Ladevorgang
           sofort — und src ist die 1400-px-Fassung. Auf dem Handy ist das grosse
           Bild aber nur 335 CSS-Punkte breit; der Browser holte also rund das
           Vierfache dessen, was er braucht, bevor er ueberhaupt erfuhr, dass es
           kleinere Fassungen gibt. Der Inhaber hat es am 06.09.2026 gemeldet:
           "wenn man auf dem handy die bilder aufmacht laden die ewig."

           Steht srcset vorher, waehlt der Browser anhand von sizes
           ("(min-width: 900px) 52vw, 94vw") die passende Stufe — auf 375 px
           sind das 600w statt 1400w. src bleibt nur der Rueckfall fuer
           Browser ohne srcset. */
        if (srcset) {
          main.srcset = srcset;
        } else {
          main.removeAttribute('srcset');
        }
        /* Vorrang vor den verzoegerten Kacheln weiter unten. Ohne das steht
           das Bild, auf das der Kunde gerade getippt hat, in derselben
           Warteschlange wie Bilder, die er noch gar nicht sieht. */
        try { main.fetchPriority = 'high'; } catch (fehler) {}
        main.src = src;
        main.alt = alt || '';
        lead.dataset.mediaId = id == null ? '' : String(id);
        markActive();
      }

      function markActive() {
        var current = lead ? lead.dataset.mediaId : '';
        root.querySelectorAll('[data-gallery-tile]').forEach(function (tile) {
          tile.classList.toggle('is-active', Boolean(current) && tile.dataset.mediaId === current);
        });
      }

      markActive();

      /* Der Finger liegt 100 bis 300 ms auf der Kachel, bevor der Tipp
         ausgeloest wird. Diese Zeit reicht, um die grosse Fassung schon
         anzufordern — beim eigentlichen Tipp liegt sie dann im
         Zwischenspeicher. Gleiche Auswahl wie beim grossen Bild, damit es
         wirklich dieselbe Adresse ist und nicht eine zweite. */
      var vorgeholt = {};

      function vorholen(tile) {
        if (!tile || !tile.dataset.src || vorgeholt[tile.dataset.mediaId]) return;
        vorgeholt[tile.dataset.mediaId] = true;
        var vorrat = new Image();
        if (main.sizes) vorrat.sizes = main.sizes;
        if (tile.dataset.srcset) vorrat.srcset = tile.dataset.srcset;
        vorrat.src = tile.dataset.src;
      }

      root.addEventListener('pointerdown', function (event) {
        vorholen(event.target.closest('[data-gallery-tile]'));
      }, { passive: true });

      /* Nach dem Tipp die beiden NACHBARKACHELN nachladen, sobald der Browser
         Luft hat. Wer eine Ansicht oeffnet, sieht sich meist auch die naechste
         an — und die ist dann sofort da. Zwei Bilder, nicht alle: die ganze
         Reihe vorzuladen waere auf dem Handy rund ein Megabyte. */
      function nachbarnVorholen(tile) {
        var alle = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-tile]'));
        var i = alle.indexOf(tile);
        if (i < 0) return;
        var spaeter = function () { vorholen(alle[i + 1]); vorholen(alle[i - 1]); };
        if (window.requestIdleCallback) {
          window.requestIdleCallback(spaeter, { timeout: 1500 });
        } else {
          setTimeout(spaeter, 400);
        }
      }

      root.addEventListener('click', function (event) {
        var tile = event.target.closest('[data-gallery-tile]');
        if (!tile) return;
        var kachelBild = tile.querySelector('img');
        show(tile.dataset.mediaId, tile.dataset.src, tile.dataset.srcset, tile.dataset.alt,
             kachelBild ? (kachelBild.currentSrc || kachelBild.src) : '');
        nachbarnVorholen(tile);
      });

      /* -------------------------------------------------- Blättern */

      function updateNav() {
        if (!track || !navButtons.length) return;
        var rest = track.scrollWidth - track.clientWidth;

        navButtons.forEach(function (button) {
          var back = parseInt(button.dataset.galleryScroll, 10) < 0;
          button.disabled = back ? track.scrollLeft < 2 : track.scrollLeft > rest - 2;
        });
      }

      if (track && navButtons.length) {
        navButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var direction = parseInt(button.dataset.galleryScroll, 10) || 1;
            track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
          });
        });

        track.addEventListener('scroll', updateNav);

        /* Der Zuhoerer am FENSTER meldet sich selbst ab.

           Im Theme-Editor laedt Shopify den Abschnitt bei jeder Einstellung
           neu, und initGallery laeuft erneut. Ohne diese Pruefung haengt nach
           jedem Neuladen ein weiterer resize-Zuhoerer am Fenster, der auf
           einen Abschnitt zeigt, den es nicht mehr gibt. In einer langen
           Sitzung wird der Editor davon spuerbar zaeh — und das sieht aus wie
           ein Fehler an der Seite selbst. */
        var beiGroesse = function () {
          if (!document.contains(root)) {
            window.removeEventListener('resize', beiGroesse);
            return;
          }
          updateNav();
        };
        window.addEventListener('resize', beiGroesse);
        updateNav();
      }

      // Farbwechsel: Bild der gewählten Variante oben zeigen, sofern eines
      // hinterlegt ist. Ohne Variantenbild bleibt die aktuelle Ansicht stehen.
      // Auch dieser meldet sich selbst ab — dieselbe Begruendung wie beim
      // resize-Zuhoerer oben.
      var beiVariante = function (event) {
        if (!document.contains(root)) {
          document.removeEventListener('pensum:variant', beiVariante);
          return;
        }
        var mediaId = event.detail && event.detail.mediaId;
        if (!mediaId) return;
        var source = sources[String(mediaId)];
        if (!source) return;
        show(mediaId, source.src, source.srcset, source.alt);
      };
      document.addEventListener('pensum:variant', beiVariante);
    });
  }

  /* ------------------------------------------------------- Variant picking */

  function initVariants(scope) {
    var roots = (scope || document).querySelectorAll('[data-variant-picker]');
    roots.forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var dataEl = root.querySelector('[data-variant-json]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var form = document.getElementById(root.dataset.formId);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceHost = document.getElementById(root.dataset.priceId);
      var submit = form ? form.querySelector('[data-add-button]') : null;

      var preisLauf = 0;

      /* Die Stelle der versteckten Option "Aufdruck" im Variantenmodell.
         Gezaehlt wird ueber die Auswahlfelder, weil abgleichen() dieselbe
         Reihenfolge benutzt, um die Variante zu finden. */
      var druckPos = -1;
      Array.prototype.forEach.call(root.querySelectorAll('select'), function (feld, i) {
        var name = String(feld.name || '').toLowerCase();
        if (name.indexOf('aufdruck') >= 0 || name.indexOf('personalis') >= 0) druckPos = i;
      });

      function ohneAufdruck(wert) {
        var w = String(wert || '').toLowerCase();
        return w.indexOf('ohne') >= 0 || w.indexOf('kein') >= 0 || w === 'nein';
      }

      /* In die ADRESSZEILE geht immer die Variante ohne Aufdruck.

         Grund: Adressen werden weitergeschickt. Sobald jemand einen Namen
         tippte, stand hier bisher ?variant=<Mit Aufdruck>, und der Warenkorb
         verlinkt den Produkttitel auf dieselbe Adresse. Beim Empfaenger gibt es
         aber nichts zu drucken — der Aufdruck lebt allein im Browser dessen,
         der ihn eingegeben hat. Lief personalizer.js beim Empfaenger nicht,
         blieb die teure Variante im Formular stehen: 2,99 EUR fuer einen leeren
         Cardholder.

         Die FARBE bleibt in der Adresse erhalten, denn die Schwestervariante
         unterscheidet sich nur im Aufdruck. Ein geteilter Link zeigt also
         weiter das richtige Stueck, nur zum ehrlichen Grundpreis.

         Das ist der billigere Weg als die serverseitige Korrektur in
         main-product.liquid: Der Server muss gar nichts geradeziehen, also
         springt auch keine Preiszeile. Die Korrektur dort bleibt trotzdem
         stehen — fuer Adressen, die schon in der Welt sind, und fuer die
         Verweise, die Shopify im Warenkorb selbst baut. */
      function adressVariante(match) {
        if (druckPos < 0 || ohneAufdruck(match.options[druckPos])) return match;
        var geschwister = variants.find(function (kandidat) {
          if (!ohneAufdruck(kandidat.options[druckPos])) return false;
          return match.options.every(function (wert, i) {
            return i === druckPos || kandidat.options[i] === wert;
          });
        });
        return geschwister || match;
      }

      function abgleichen(erstlauf) {
        var selected = Array.prototype.map.call(root.querySelectorAll('select'), function (s) { return s.value; });

        var match = variants.find(function (variant) {
          return selected.every(function (value, index) {
            return variant.options[index] === value;
          });
        });

        if (!match) {
          if (submit) {
            submit.setAttribute('aria-disabled', 'true');
            submit.dataset.gesperrt = 'true';
            submit.textContent = window.Theme.strings.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        document.dispatchEvent(new CustomEvent('pensum:variant', {
          detail: {
            variant: match,
            mediaId: match.featured_media ? match.featured_media.id : null
          }
        }));

        if (submit) {
          if (match.available) {
            submit.removeAttribute('aria-disabled');
            delete submit.dataset.gesperrt;
            submit.textContent = window.Theme.strings.addToCart;
          } else {
            submit.setAttribute('aria-disabled', 'true');
            submit.dataset.gesperrt = 'true';
            submit.textContent = window.Theme.strings.soldOut;
          }
        }

        if (priceHost) {
          // Wer schnell zwischen Farben wechselt, hat mehrere Abrufe zugleich
          // unterwegs. Ohne Nummer koennte die langsamere, aeltere Antwort
          // zuletzt eintreffen — dann stuende ein Preis da, der nicht zur
          // gewaehlten Variante gehoert.
          preisLauf += 1;
          var dieserLauf = preisLauf;

          var base = root.dataset.productUrl || window.location.pathname;
          var url = base + '?section_id=' + root.dataset.sectionId + '&variant=' + match.id;
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              if (dieserLauf !== preisLauf) return;
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var fresh = parsed.getElementById(root.dataset.priceId);
              if (fresh) priceHost.innerHTML = fresh.innerHTML;
            })
            .catch(function () { /* silent */ });
        }

        if (history.replaceState) {
          var newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', adressVariante(match).id);
          history.replaceState({}, '', newUrl.toString());
        }
      }

      root.addEventListener('change', function () { abgleichen(false); });

      // Einmal gleich beim Binden abgleichen. personalizer.js läuft vor dieser
      // Datei und stellt die versteckte Aufdruck-Option nach dem Namensfeld —
      // dieses erste change-Ereignis hört sonst niemand. Wer die Seite mit
      // ?variant=<Mit Aufdruck> neu lädt oder den Link teilt, hätte danach ein
      // leeres Namensfeld, aber die teurere Variante im Kaufformular: 2,99 €
      // für einen Cardholder ohne Aufdruck.
      //
      // Derselbe Abgleich fängt auch den Fall ab, dass die günstigste Variante
      // einer Farbe ausverkauft ist und Shopify von sich aus eine
      // Aufpreis-Variante vorauswählt.
      if (idInput) {
        var sollWerte = Array.prototype.map.call(root.querySelectorAll('select'), function (s) { return s.value; });
        var soll = variants.find(function (variant) {
          return sollWerte.every(function (value, index) { return variant.options[index] === value; });
        });
        if (soll && String(soll.id) !== String(idInput.value)) abgleichen(true);
      }
    });
  }

  /* ------------------------------------------------------ Flug zum Korb */

  // Die Zahl neben dem Warenkorb kurz aufziehen. Das ist die eigentliche
  // Bestätigung — der Flug darüber ist nur die Spur dorthin.
  function bumpCart() {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.classList.remove('is-bumped');
    // Ohne Reflow startet dieselbe Animation beim zweiten Mal nicht neu.
    void badge.offsetWidth;
    badge.classList.add('is-bumped');
  }

  // Nach dem Hinzufügen fliegt ein kleines Abbild des Produkts zum
  // Warenkorb. Auf einer so ruhigen Seite merkt man sonst kaum, dass
  // überhaupt etwas passiert ist.
  function flyToCart(form) {
    var target = document.querySelector('[data-cart-count]');
    if (!target || reduceMotion) return bumpCart();

    // Der Flug startet am Kaufknopf — dort hat der Kunde gerade geklickt und
    // dorthin schaut er. Was fliegt, ist trotzdem das Produktbild, damit
    // erkennbar bleibt, was in den Warenkorb geht.
    var button = form && form.querySelector('[data-add-button]');
    var image = document.querySelector('[data-gallery-main]');
    var origin = button || image;
    if (!origin) return bumpCart();

    var from = origin.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return bumpCart();

    var size = 76;
    var flyer = document.createElement('div');
    flyer.className = 'fly-to-cart';
    flyer.setAttribute('aria-hidden', 'true');

    if (image && (image.currentSrc || image.src)) {
      flyer.style.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';
    }

    flyer.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    flyer.style.top = (from.top + from.height / 2 - size / 2) + 'px';
    document.body.appendChild(flyer);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    // Den Startwert erzwingen, damit der Browser die Änderung als Übergang
    // sieht. Bewusst über einen Umbruch statt über requestAnimationFrame:
    // dessen Rückrufe laufen nicht, solange die Seite nicht gezeichnet wird —
    // etwa wenn der Kunde gleich nach dem Klick den Tab wechselt.
    void flyer.offsetWidth;

    flyer.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)';
    flyer.style.opacity = '0.15';

    var beendet = false;
    function aufraeumen() {
      if (beendet) return;
      beendet = true;
      if (flyer.parentNode) flyer.parentNode.removeChild(flyer);
      bumpCart();
    }

    flyer.addEventListener('transitionend', aufraeumen);
    // Fällt das Ereignis aus — etwa weil der Reiter im Hintergrund liegt —
    // räumt der Zeitgeber auf, damit nichts kleben bleibt.
    setTimeout(aufraeumen, 900);
  }

  /* --------------------------------------------------------- Add to cart */

  function initProductForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-product-form]');
      if (!form) return;

      // Enthält die Bestellung ein hochgeladenes Motiv, muss das Formular
      // regulär abgeschickt werden — Dateien kann die Cart-AJAX-API nicht.
      if (form.dataset.nativeSubmit === 'true') return;

      event.preventDefault();

      // Zweiter Absender, während der erste noch läuft: aria-disabled hält nur
      // die Maus ab (base.css setzt pointer-events: none), die Eingabetaste im
      // Namensfeld schickt das Formular trotzdem ab. Ohne diese Sperre läge
      // alles zweimal im Warenkorb.
      if (form.dataset.busy === 'true') return;
      form.dataset.busy = 'true';

      var button = form.querySelector('[data-add-button]');
      var original = button ? button.textContent : '';

      /* Während des Hinzufügens stand hier nur „…". Das sagt nichts — der
         Kunde weiß nicht, ob es lädt, hängt oder er danebengetippt hat.

         Und die mitlaufende Leiste wird mitgeführt: Auf dem Handy tippt der
         Kunde SIE an, der echte Knopf ist dabei definitionsgemäß aus dem Bild
         gescrollt. Ohne die Spiegelung sähe er also überhaupt keine Reaktion,
         während im Hintergrund der Knopf gesperrt ist und jeden weiteren
         Tipp schluckt. */
      var leistenKnopf = document.querySelector('[data-buy-bar-add]');
      var leistenOriginal = leistenKnopf ? leistenKnopf.textContent : '';

      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = window.Theme.strings.adding || '…';
      }
      if (leistenKnopf) {
        leistenKnopf.setAttribute('aria-disabled', 'true');
        leistenKnopf.textContent = window.Theme.strings.adding || '…';
      }

      var body = new FormData(form);

      // Aufpreis und Menge im selben Augenblick festhalten wie das Formular
      // selbst. Ausgewertet wurden sie früher erst nach der Antwort des
      // Servers — wer in der Zwischenzeit weitertippte oder den Namen löschte,
      // bekam einen Aufdruck ohne Aufpreis oder einen Aufpreis ohne Aufdruck.
      var extra = form.dataset.extraVariant;
      var extraNote = form.dataset.extraNote;
      var quantityInput = form.querySelector('input[name="quantity"]');
      var quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);

      fetch(window.Theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            showToast(result.data.description || result.data.message || window.Theme.strings.unavailable);
            return;
          }

          /* Zweites Argument true = der Kasten bleibt stehen und zeigt
             "Zur Kasse". Er ist nach dem Hinzufuegen der einzige sichtbare Weg
             nach vorn; siehe die Begruendung im Markup in layout/theme.liquid.

             ABER NUR, WENN NICHTS MEHR NACHKOMMT. Steht ein Aufpreis aus, ist
             der Warenkorb in diesem Augenblick noch unvollstaendig; ein Kunde,
             der jetzt "Zur Kasse" tippt, kaufte einen bedruckten Cardholder
             ohne die 2,99 EUR. Der Weg erscheint deshalb erst unten, wenn die
             zweite Zeile wirklich drin ist. (Heute tragen beide Produkte die
             Option "Aufdruck" als Variante, extra bleibt also leer — der Zweig
             existiert fuer ein Produkt ohne diese Option.) */
          showToast(window.Theme.strings.added, !extra);
          flyToCart(form);

          // Hat der Konfigurator einen Aufpreis vermerkt, kommt er als eigene
          // Zeile hinterher — erst wenn der Hauptartikel wirklich drin ist.
          if (!extra) return refreshCartCount();

          var properties = {};
          if (extraNote) properties['_Gehört zu'] = extraNote;

          return fetch(window.Theme.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(extra), quantity: quantity, properties: properties }] })
          })
            .then(function (response) {
              // Scheitert der Aufpreis, liegt der Hauptartikel längst im Korb
              // und der Kunde hat die Erfolgsmeldung gesehen. Stillschweigend
              // übergehen hieße: bedruckter Cardholder ohne die 2,99 €, ohne
              // jede Spur. Deshalb wird es gesagt.
              if (!response.ok) { showToast(window.Theme.strings.surchargeFailed); return; }
              // Jetzt ist der Korb vollstaendig — erst jetzt der Weg zur Kasse.
              showToast(window.Theme.strings.added, true);
            })
            .catch(function () { showToast(window.Theme.strings.surchargeFailed); })
            .then(refreshCartCount);
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          delete form.dataset.busy;
          if (button) {
            // Nicht blind zuruecksetzen: Waehrend der Anfrage kann der
            // Variantenwechsel den Knopf auf ausverkauft gestellt haben.
            // Diesen Zustand wieder zu ueberschreiben hiesse, einen
            // unverkaeuflichen Artikel als kaufbar anzubieten.
            if (button.dataset.gesperrt !== 'true') {
              button.removeAttribute('aria-disabled');
              button.textContent = original;
            }
          }
          if (leistenKnopf) {
            leistenKnopf.removeAttribute('aria-disabled');
            leistenKnopf.textContent = leistenOriginal;
          }
        });
    });
  }

  /* -------------------------------------------------------------- Cart page */

  function initCartPage() {
    // Kurz warten statt sofort abschicken. Der Knopf loest bei jedem Tipp ein
    // change aus; ohne Wartezeit laedt die Seite schon beim ersten neu, und
    // wer zweimal schnell auf Plus tippt, verliert den zweiten Tipp. Auf dem
    // Handy tippt man aber genau so.
    var absendeTimer = null;
    var schonUnterwegs = false;

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      var form = input.closest('form');
      if (!form) return;

      clearTimeout(absendeTimer);
      absendeTimer = setTimeout(function () {
        if (schonUnterwegs) return;
        form.submit();
      }, 550);
    });

    // Schickt der Kunde das Formular in diesen 550 ms selbst ab — über „Zur
    // Kasse" oder über die mitlaufende Leiste —, muss der wartende Zeitgeber
    // weg. Sonst feuert er hinterher ein zweites, programmatisches submit().
    // Ein programmatischer Aufruf trägt den Absendeknopf nicht mit, das Feld
    // "checkout" fehlt also, und Shopify leitet zurück auf /cart: Der Kunde
    // tippt auf Plus, dann auf „Zur Kasse" — und landet wieder im Warenkorb.
    //
    // Mit der Kaufleiste ist das kein Randfall mehr, weil „Zur Kasse" jetzt
    // direkt unter dem Mengenschalter liegt. Genau diese Reihenfolge ist die
    // natürliche.
    //
    // Der Warenkorb wird dabei NICHT geleert. Die Artikel bleiben liegen, bis
    // Shopify sie nach abgeschlossener Bestellung selbst entfernt; wer den
    // Checkout abbricht und zurückgeht, findet alles wieder vor.
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart"]');
      if (!form) return;
      schonUnterwegs = true;
      clearTimeout(absendeTimer);
    }, true);

    syncSurcharge();
    initCartPreview();
  }

  // Der Aufpreis fuer den Aufdruck liegt als eigene Zeile im Warenkorb. Aendert
  // der Kunde hier die Menge des Cardholders oder entfernt ihn ganz, weiss
  // Shopify von dem Zusammenhang nichts — die Aufpreis-Zeile bliebe stehen.
  // Der Kunde zahlte dann zu viel oder haette am Ende eine Gebuehr ohne Ware
  // im Korb. Deshalb wird beides hier nach jedem Laden der Seite abgeglichen.
  //
  // Zusammengehalten wird ueber die Eigenschaft "_Gehoert zu": Sie steht auf
  // der Aufpreis-Zeile und traegt den Titel des Artikels, zu dem sie gehoert.
  // So bleiben auch zwei verschieden personalisierte Produkte auseinander.
  /* --------------------------------------------- Vorschau im Warenkorb */

  /* Baut je Warenkorbzeile das personalisierte Stück nach. Alle Angaben stehen
     schon in der Eigenschaft _Druckvorlage, die beim Kauf mitgeschrieben wird —
     Foto, Text, Schrift, Druckfarbe, Position und Größe. Es braucht also weder
     eine erzeugte Bilddatei noch einen Upload.

     Die Größen sind Anteile der Bildbreite, nicht feste Pixel. Deshalb müssen
     sie nach jeder Größenänderung des Fensters neu gerechnet werden, sonst
     wandert der Aufdruck. */
  function initCartPreview(scope) {
    var vorschauen = (scope || document).querySelectorAll('[data-cart-vorschau]');
    if (!vorschauen.length) return;

    var anteile = [];

    function ankerLesen(anker) {
      var daten = {};
      // Die Trennzeichen kommen je nach Maskierung als & oder als &amp; an.
      // Beides zulassen, statt sich auf eine Schreibweise zu verlassen.
      String(anker).replace(/&amp;/g, '&').split('&').forEach(function (paar) {
        var trenner = paar.indexOf('=');
        if (trenner < 1) return;
        try {
          daten[paar.slice(0, trenner)] = decodeURIComponent(paar.slice(trenner + 1));
        } catch (fehler) {
          daten[paar.slice(0, trenner)] = paar.slice(trenner + 1);
        }
      });
      return daten;
    }

    function ebene(el, inhalt, x, y, z, schrift, tinte, laufweite) {
      if (!el || !inhalt) {
        if (el) el.hidden = true;
        return;
      }

      el.textContent = inhalt;
      el.hidden = false;
      if (x) el.style.setProperty('--cv-x', parseFloat(x) + '%');
      if (y) el.style.setProperty('--cv-y', parseFloat(y) + '%');

      // Roh festhalten. Die Grossansicht zeigt dasselbe Foto ungeschnitten und
      // muss die Werte in deren Bezug umrechnen — siehe entzerren() in
      // initVorschauGross. Aus dem fertigen Prozentwert ginge das nicht mehr,
      // weil dort nicht mehr steht, worauf er sich bezog.
      if (x) el.dataset.cvX = parseFloat(x);
      if (y) el.dataset.cvY = parseFloat(y);
      if (schrift) el.style.setProperty('--cv-font', '"' + schrift + '", serif');
      if (tinte) el.style.setProperty('--cv-ink', '#' + String(tinte).replace('#', ''));
      if (laufweite) el.style.setProperty('--cv-track', laufweite);

      var anteil = parseFloat(z);
      if (!isNaN(anteil)) {
        anteile.push({ el: el, anteil: anteil });
        // Auch an der Ebene selbst festhalten. Die Großansicht arbeitet mit
        // einer Kopie dieses Knotens und muss die Schriftgröße dort gegen
        // eine andere Breite neu rechnen — ohne den Anker noch einmal zu
        // zerlegen.
        el.dataset.cvAnteil = anteil;
      }
    }

    Array.prototype.forEach.call(vorschauen, function (rahmen) {
      var daten = ankerLesen(rahmen.dataset.cartVorschau || '');

      // ia ist die Farbe, wie sie in der Vorschau zu sehen war; i ist der rohe
      // Druckwert. Fuer die Anzeige zaehlt die erste, damit der Warenkorb
      // dasselbe zeigt wie der Konfigurator.
      var anzeigeFarbe = daten.ia || daten.i;

      ebene(rahmen.querySelector('[data-cart-vorschau-text]'),
        daten.t, daten.x, daten.y, daten.z, daten.f, anzeigeFarbe, daten.l);

      // Das Zeichen hat eine eigene Schrift und keine Laufweite.
      ebene(rahmen.querySelector('[data-cart-vorschau-zeichen]'),
        daten.s, daten.sx, daten.sy, daten.sz, daten.sf || 'Pensum Antiqua', anzeigeFarbe, null);
    });

    function skalieren() {
      anteile.forEach(function (eintrag) {
        var rahmen = eintrag.el.parentElement;
        var breite = rahmen ? rahmen.clientWidth : 0;
        if (!breite) return;
        eintrag.el.style.setProperty('--cv-fs', (breite * eintrag.anteil / 100) + 'px');
      });
    }

    skalieren();
    window.addEventListener('resize', skalieren);

    // Die Schriften kommen als Datei nach; ohne dieses zweite Rechnen säße der
    // Aufdruck an der Stelle, die die Ersatzschrift ergeben hat.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(skalieren);
    }
  }

  var ABGLEICH = 'pensum:aufpreis-abgleich';

  function syncSurcharge() {
    var wurzel = document.querySelector('[data-cart]');
    if (!wurzel) return;

    // Die Kasse wird nur gesperrt, wenn wirklich etwas zu korrigieren ist —
    // und erst dann. Vorher pauschal zu sperren hiess: Bei jedem Laden des
    // Warenkorbs war der Knopf tot, bis /cart.js geantwortet hat, und blieb
    // es fuer immer, wenn die Antwort ausblieb.
    var kasse = document.querySelector('[name="checkout"], [data-checkout]');
    function kasseSperren() { if (kasse) kasse.setAttribute('aria-disabled', 'true'); }
    function kasseFrei() { if (kasse) kasse.removeAttribute('aria-disabled'); }

    var aufpreisVariante = wurzel.dataset.cartSurcharge;

    fetch(window.Theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var noetig = {};   // Titel des Artikels -> wie viele Aufdrucke gebraucht werden
        var vorhanden = {}; // Titel -> { zeile, menge }

        cart.items.forEach(function (item, index) {
          var eigenschaften = item.properties || {};
          var gehoertZu = eigenschaften['_Gehört zu'];

          if (gehoertZu) {
            vorhanden[gehoertZu] = { zeile: index + 1, menge: item.quantity };
            return;
          }

          // Traegt der Artikel selbst eine Option „Aufdruck", steckt der
          // Aufpreis schon im Variantenpreis. Dann darf hier auf keinen Fall
          // eine zweite Zeile entstehen — der Kunde zahlte sonst doppelt.
          // Nicht nur der Name der Option zaehlt, sondern ihr Wert. Eine alte
          // Zeile kann auf einer Variante "Ohne Aufdruck" liegen und trotzdem
          // eine Aufdruck-Eigenschaft tragen — dann steckt der Aufpreis eben
          // NICHT im Preis, und die alte 2,99-Zeile darf nicht verschwinden.
          var ueberVariante = (item.options_with_values || []).some(function (o) {
            var name = String(o.name || '').toLowerCase();
            if (name.indexOf('aufdruck') < 0 && name.indexOf('personalis') < 0) return false;
            var wert = String(o.value || '').toLowerCase();
            var ohne = wert.indexOf('ohne') >= 0 || wert.indexOf('kein') >= 0 || wert === 'nein';
            return !ohne;
          });
          if (ueberVariante) return;

          // Personalisiert ist, was einen Aufdruck oder ein Zeichen traegt —
          // dieselbe Bedingung, unter der die Produktseite den Aufpreis setzt.
          if (eigenschaften['Aufdruck'] || eigenschaften['Zeichen']) {
            var titel = item.product_title || item.title;
            noetig[titel] = (noetig[titel] || 0) + item.quantity;
          }
        });

        var aufgaben = [];

        // Zu viel oder verwaist: Menge korrigieren, notfalls auf null.
        Object.keys(vorhanden).forEach(function (titel) {
          var soll = noetig[titel] || 0;
          if (soll !== vorhanden[titel].menge) {
            aufgaben.push({ art: 'aendern', zeile: vorhanden[titel].zeile, menge: soll });
          }
        });

        // Zu wenig: Der Kunde hat die Aufpreis-Zeile geloescht, den bedruckten
        // Artikel aber behalten. Ohne die Variantennummer laesst sich das nicht
        // heilen — dann bleibt es, wie es ist.
        if (aufpreisVariante) {
          Object.keys(noetig).forEach(function (titel) {
            if (!vorhanden[titel]) {
              aufgaben.push({ art: 'hinzufuegen', titel: titel, menge: noetig[titel] });
            }
          });
        }

        if (!aufgaben.length) {
          try { sessionStorage.removeItem(ABGLEICH); } catch (fehler) { /* ohne Speicher weiter */ }
          kasseFrei();
          return;
        }

        // Riegel gegen eine Schleife: Jede Korrektur laedt die Seite neu, und
        // das Neuladen stoesst diesen Abgleich wieder an. Konvergiert er nicht
        // — etwa weil der Aufpreis-Artikel nicht mehr kaufbar ist —, laege der
        // Kunde sonst in einer Dauerschleife und kaeme nicht mehr zur Kasse.
        var versuche = 0;
        try { versuche = Number(sessionStorage.getItem(ABGLEICH)) || 0; } catch (fehler) { /* ohne Speicher weiter */ }
        if (versuche >= 2) { kasseFrei(); return; }

        // Ab hier wird der Warenkorb wirklich veraendert.
        kasseSperren();

        // Nacheinander, nicht gleichzeitig: Shopify vergibt die Zeilennummern
        // bei jeder Aenderung neu, parallele Aufrufe wuerden sich verrechnen.
        // Aus demselben Grund wird nach der ersten Aenderung abgebrochen und
        // neu geladen — die uebrigen Nummern stammen aus dem alten Stand.
        var gelungen = 0;
        var gescheitert = 0;

        return aufgaben.reduce(function (kette, aufgabe, index) {
          return kette.then(function () {
            if (index > 0 && gelungen > 0) return null;

            var anfrage = aufgabe.art === 'aendern'
              ? fetch(window.Theme.routes.cartChange + '.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ line: aufgabe.zeile, quantity: aufgabe.menge })
                })
              : fetch(window.Theme.routes.cartAdd + '.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({
                    items: [{
                      id: Number(aufpreisVariante),
                      quantity: aufgabe.menge,
                      properties: { '_Gehört zu': aufgabe.titel }
                    }]
                  })
                });

            return anfrage.then(function (antwort) {
              if (antwort.ok) gelungen += 1; else gescheitert += 1;
            }).catch(function () { gescheitert += 1; });
          });
        }, Promise.resolve()).then(function () {
          if (gescheitert && !gelungen) {
            // Nicht neu laden: Der Warenkorb steht unveraendert da, und eine
            // Seite, die sich stumm wiederholt neu laedt, ist schlimmer als
            // eine Zeile, die stehen bleibt.
            // Hier wird nur aufgeraeumt, nichts hinzugefuegt — die alte
            // Meldung haette vom Hinzufuegen eines Aufpreises gesprochen, den
            // es gar nicht mehr gibt.
            showToast(window.Theme.strings.surchargeCleanupFailed || window.Theme.strings.surchargeFailed);
            kasseFrei();
            return;
          }
          if (!gelungen) { kasseFrei(); return; }
          try { sessionStorage.setItem(ABGLEICH, String(versuche + 1)); } catch (fehler) { /* ohne Speicher weiter */ }
          window.location.reload();
        });
      })
      .catch(function () { kasseFrei(); /* lieber ein unveraenderter Warenkorb als eine kaputte Seite */ });
  }

  /* --------------------------------------------------------- Collection sort */

  function initSort() {
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-sort-select]');
      if (!select) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------------------------------------------------------------- Sharing */

  function initShare() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-share]');
      if (!button) return;
      event.preventDefault();
      var url = button.dataset.share || window.location.href;

      if (navigator.share) {
        navigator.share({ url: url, title: document.title }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          showToast(window.Theme.strings.copied);
        });
      }
    });
  }

  /* ------------------------------------------------------------------- Boot */

  /* ------------------------------------------------------- Einblendungen */

  /* Warenkorb und Produktseite blenden beide etwas über der Seite ein: dort
     den Aufdruck groß, hier die Produktbeschreibung. Beide teilen sich Hülle,
     Verhalten und Schließwege — deshalb liegt das Öffnen bei der jeweiligen
     Sache und das Schließen hier, einmal für alle.

     Warum Einblendung und nicht eigene Seite oder Aufklapper: Ein
     Seitenwechsel ist eine Gelegenheit abzuspringen, und ein Aufklapper
     schiebt beim Öffnen alles darunter weg — der Kaufknopf rutscht dem Kunden
     mitten im Lesen davon. Die Einblendung lässt die Seite stehen. */

  var offeneEinblendung = null;
  var einblendungZurueckZu = null;

  function einblendungOeffnen(schicht, ausloeser) {
    offeneEinblendung = schicht;
    einblendungZurueckZu = ausloeser || null;
    schicht.hidden = false;
    document.body.style.overflow = 'hidden';
    var zu = schicht.querySelector('[data-einblendung-zu]');
    if (zu && zu.focus) zu.focus();
  }

  function einblendungSchliessen() {
    if (!offeneEinblendung) return;
    var schicht = offeneEinblendung;
    schicht.hidden = true;
    document.body.style.overflow = '';
    // Die Bühne leeren, damit kein großes Bild im Speicher liegen bleibt und
    // die nächste Einblendung nicht kurz den vorigen Inhalt zeigt.
    var buehne = schicht.querySelector('[data-vorschau-buehne]');
    if (buehne) {
      buehne.innerHTML = '';
      // Sonst öffnet die nächste Vorschau bereits herangezoomt.
      buehne.classList.remove('is-zoom');
      buehne.scrollLeft = 0;
      buehne.scrollTop = 0;
    }
    if (einblendungZurueckZu && einblendungZurueckZu.focus) einblendungZurueckZu.focus();
    offeneEinblendung = null;
    einblendungZurueckZu = null;
  }

  function initEinblendungen() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-einblendung-zu]')) {
        event.preventDefault();
        einblendungSchliessen();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') einblendungSchliessen();
    });
  }

  /* --------------------------------------- Großansicht des Aufdrucks */

  /* Der Daumen in der Warenkorbzeile ist rund 92 px groß, der Aufdruck darin
     knapp 6 px. Der Warenkorb ist aber die letzte Stelle vor der Zahlung, an
     der jemand seinen Aufdruck prüfen kann, und bei personalisierter Ware ist
     der Widerruf ausgeschlossen.

     Die Ansicht wird nicht neu aufgebaut, sondern aus der angeklickten Zeile
     kopiert. Damit gibt es weiterhin genau eine Stelle, die aus dem Anker
     Ebenen macht (initCartPreview) — eine zweite Fassung wäre die Stelle, an
     der Warenkorb und Großansicht eines Tages Verschiedenes zeigen. */
  function initVorschauGross() {
    var schicht = document.querySelector('[data-vorschau-gross]');
    if (!schicht) return;

    var buehne = schicht.querySelector('[data-vorschau-buehne]');
    var zeile = schicht.querySelector('[data-vorschau-zeile]');

    /* Gemessen wird der Rahmen der Vorschau, nicht die Bühne. Beim Zoomen
       wird er breiter als die Bühne — hinge die Schriftgröße an der Bühne,
       bliebe der Aufdruck beim Heranzoomen gleich groß, während das Foto
       wächst. Dann stünde der Name plötzlich woanders. */
    /* Der Aufdruck sass hier zu tief — bei hellen Farben rutschte er sogar
       unter die Karte. Grund ist der Zuschnitt, nicht die Position:

       Die Buehne im Konfigurator und die Zeile im Warenkorb sind quadratisch
       und schneiden das hochformatige Foto oben und unten an
       (object-fit: cover). Auf DIESEN Ausschnitt sind x und y eingemessen.
       Hier ist das ganze Foto zu sehen, die Flaeche also hoeher — dieselbe
       Prozentzahl liegt damit weiter unten.

       Umgerechnet wird ueber das Seitenverhaeltnis a = Hoehe/Breite: Beim
       Zuschnitt auf das Quadrat faellt oben und unten je (a-1)/2 der Breite
       weg. Ein Punkt bei fy des Quadrats liegt im vollen Foto deshalb bei

           (fy + (a-1)/2) / a

       Bei einem querformatigen Foto wird stattdessen links und rechts
       geschnitten; dann gilt dasselbe spiegelbildlich fuer x. */
    function entzerren() {
      var foto = buehne.querySelector('[data-cart-vorschau-foto]');
      var bw = (foto && foto.naturalWidth) || parseFloat(buehne.dataset.fotoBreite) || 0;
      var bh = (foto && foto.naturalHeight) || parseFloat(buehne.dataset.fotoHoehe) || 0;
      if (!bw || !bh) return;

      Array.prototype.forEach.call(buehne.querySelectorAll('[data-cv-anteil]'), function (el) {
        var x = parseFloat(el.dataset.cvX);
        var y = parseFloat(el.dataset.cvY);
        if (isNaN(x) || isNaN(y)) return;

        if (bh >= bw) {
          var a = bh / bw;
          y = (y / 100 + (a - 1) / 2) / a * 100;
        } else {
          var b = bw / bh;
          x = (x / 100 + (b - 1) / 2) / b * 100;
        }

        el.style.setProperty('--cv-x', x + '%');
        el.style.setProperty('--cv-y', y + '%');
      });
    }

    function skalieren() {
      var rahmen = buehne.querySelector('.cart-vorschau');
      var breite = rahmen ? rahmen.clientWidth : buehne.clientWidth;
      if (!breite) return;
      entzerren();
      Array.prototype.forEach.call(buehne.querySelectorAll('[data-cv-anteil]'), function (el) {
        var anteil = parseFloat(el.dataset.cvAnteil);
        if (!isNaN(anteil)) el.style.setProperty('--cv-fs', (breite * anteil / 100) + 'px');
      });
    }

    /* Ein Tipp auf das Bild zoomt heran, der nächste wieder heraus. Zoomen
       über die Breite statt über transform: scale, damit die Schrift über
       dieselbe Rechnung mitwächst wie sonst auch — und damit die Bühne
       scrollbar wird, statt dass das Bild über den Rand hinausragt.

       Der angetippte Punkt bleibt dabei ungefähr unter dem Finger: Die
       Scrollposition wird auf die Stelle gesetzt, an der getippt wurde. */
    /* --------------------------------------------------- Zoomen im Bild

       Zwei Finger auseinanderziehen vergrößert, zusammenziehen verkleinert,
       und der Punkt ZWISCHEN den Fingern bleibt dabei stehen — wie in der
       Fotos-App. Mit einem Finger wird danach geschoben. Ein einzelner Tipp
       bleibt als schneller Weg erhalten.

       Gerechnet wird mit Ursprung 0 0 und translate+scale statt mit einem
       wandernden transform-origin. Grund: Nur so lässt sich ein Punkt exakt
       festhalten. Ein Punkt p im Rahmen landet auf dem Schirm bei s·p + t;
       soll p unter dem Finger m bleiben, ergibt sich t = m − s·(m − t₀)/s₀.

       Alles wird inline gesetzt, nicht über CSS-Regeln — an diesem Element
       blieben Regeln aus einer Nachfahren-Auswahl wirkungslos, siehe die
       Notiz vom 01.09.2026. */

    var ZOOM_TIPP = 2.4;
    var ZOOM_MAX = 4;

    var zoom = { s: 1, x: 0, y: 0 };
    var finger = {};
    var kniff = null;        // Ausgangswerte einer Zwei-Finger-Geste
    var tippStart = null;    // unterscheidet Tippen von Ziehen
    var gesteBis = 0;        // sperrt den Tipp kurz nach einer Geste

    function zoomRahmenEl() { return buehne.querySelector('.vorschau-gross__zoombar'); }

    function anwenden(weich) {
      var el = zoomRahmenEl();
      if (!el) return;
      el.style.transition = weich ? 'transform 0.24s ease' : 'none';
      el.style.transformOrigin = '0 0';
      el.style.transform =
        'translate(' + zoom.x + 'px, ' + zoom.y + 'px) scale(' + zoom.s + ')';
      buehne.classList.toggle('is-zoom', zoom.s > 1.01);
    }

    /* Nicht über den Rand hinausschieben: Der Rahmen soll die Bühne immer
       ausfüllen, sonst steht plötzlich Weiß neben dem Cardholder. */
    function inGrenzen() {
      var el = zoomRahmenEl();
      if (!el) return;
      var b = buehne.clientWidth;
      var h = el.offsetHeight || buehne.clientHeight;
      zoom.x = Math.min(0, Math.max(b - b * zoom.s, zoom.x));
      zoom.y = Math.min(0, Math.max(h - h * zoom.s, zoom.y));
    }

    function zoomZuruecksetzen(weich) {
      zoom = { s: 1, x: 0, y: 0 };
      anwenden(weich);
    }

    function abstand(a, b) {
      return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
    }

    buehne.addEventListener('pointerdown', function (event) {
      if (!zoomRahmenEl()) return;
      finger[event.pointerId] = { x: event.clientX, y: event.clientY };
      try { buehne.setPointerCapture(event.pointerId); } catch (fehler) {}

      var ids = Object.keys(finger);
      if (ids.length === 1) {
        tippStart = { x: event.clientX, y: event.clientY };
        kniff = null;
      } else if (ids.length === 2) {
        tippStart = null;
        var a = finger[ids[0]], b = finger[ids[1]];
        kniff = {
          d: abstand(a, b),
          mx: (a.x + b.x) / 2,
          my: (a.y + b.y) / 2,
          s: zoom.s, x: zoom.x, y: zoom.y
        };
      }
    });

    buehne.addEventListener('pointermove', function (event) {
      var vorher = finger[event.pointerId];
      if (!vorher) return;

      var dx = event.clientX - vorher.x;
      var dy = event.clientY - vorher.y;
      finger[event.pointerId] = { x: event.clientX, y: event.clientY };

      var ids = Object.keys(finger);
      var r = buehne.getBoundingClientRect();

      if (ids.length >= 2 && kniff && kniff.d > 0) {
        event.preventDefault();
        var a = finger[ids[0]], b = finger[ids[1]];
        var s = Math.min(ZOOM_MAX, Math.max(1, kniff.s * (abstand(a, b) / kniff.d)));

        // Der Punkt, der beim Beginn der Geste unter der Fingermitte lag,
        // bleibt unter der neuen Fingermitte.
        var mx = (a.x + b.x) / 2 - r.left;
        var my = (a.y + b.y) / 2 - r.top;
        var m0x = kniff.mx - r.left;
        var m0y = kniff.my - r.top;

        zoom.s = s;
        zoom.x = mx - (s / kniff.s) * (m0x - kniff.x);
        zoom.y = my - (s / kniff.s) * (m0y - kniff.y);

        inGrenzen();
        anwenden(false);
        gesteBis = Date.now() + 350;
        return;
      }

      if (ids.length === 1 && zoom.s > 1.01) {
        event.preventDefault();
        zoom.x += dx;
        zoom.y += dy;
        inGrenzen();
        anwenden(false);
        if (tippStart &&
            (Math.abs(event.clientX - tippStart.x) > 6 ||
             Math.abs(event.clientY - tippStart.y) > 6)) {
          tippStart = null;
          gesteBis = Date.now() + 350;
        }
      }
    });

    function fingerWeg(event) {
      if (!finger[event.pointerId]) return;
      delete finger[event.pointerId];
      try { buehne.releasePointerCapture(event.pointerId); } catch (fehler) {}
      if (Object.keys(finger).length < 2) kniff = null;
      // Unter Originalgröße nicht stehen lassen, sondern sauber zurück.
      if (zoom.s <= 1.01) zoomZuruecksetzen(true);
    }

    buehne.addEventListener('pointerup', fingerWeg);
    buehne.addEventListener('pointercancel', fingerWeg);

    /* Trackpad und Mausrad.

       Beides kommt als wheel an — das Kneifen auf dem Trackpad schickt der
       Browser als wheel mit gedrückter Strg-Taste und in feinen Schritten,
       das Mausrad in groben. Deshalb zwei Empfindlichkeiten, sonst springt
       das Bild beim Trackpad und kriecht beim Rad.

       Gezoomt wird auf den Mauszeiger, nach derselben Rechnung wie bei den
       Fingern: Der Punkt unter dem Zeiger bleibt stehen.

       passive: false, weil preventDefault sonst nicht greift — ohne das
       zoomt der Browser die ganze Seite statt nur das Bild. */
    buehne.addEventListener('wheel', function (event) {
      if (!zoomRahmenEl()) return;
      event.preventDefault();

      var r = buehne.getBoundingClientRect();
      if (!r.width || !r.height) return;

      var mx = event.clientX - r.left;
      var my = event.clientY - r.top;

      // deltaMode 1 zählt in Zeilen statt in Pixeln (Firefox, manche Mäuse).
      var delta = event.deltaY * (event.deltaMode === 1 ? 16 : 1);
      var schritt = event.ctrlKey ? 0.01 : 0.0022;
      var alt = zoom.s;
      var s = Math.min(ZOOM_MAX, Math.max(1, alt * Math.exp(-delta * schritt)));
      if (s === alt) return;

      zoom.s = s;
      zoom.x = mx - (s / alt) * (mx - zoom.x);
      zoom.y = my - (s / alt) * (my - zoom.y);

      if (s <= 1.01) {
        zoomZuruecksetzen(false);
        return;
      }

      inGrenzen();
      anwenden(false);
      // Sperrt den Tipp kurz, sonst zoomt ein Klick direkt nach dem Rad
      // gleich wieder auf die feste Stufe.
      gesteBis = Date.now() + 350;
    }, { passive: false });

    /* Ein einzelner Tipp als Abkürzung: heranzoomen auf die getippte Stelle,
       nächster Tipp zurück. Nach einer Finger-Geste kurz gesperrt, sonst
       schaltet das Loslassen zweier Finger noch einen Tipp hinterher. */
    buehne.addEventListener('click', function (event) {
      if (!zoomRahmenEl()) return;
      if (Date.now() < gesteBis) return;

      var r = buehne.getBoundingClientRect();
      if (zoom.s > 1.01) { zoomZuruecksetzen(true); return; }

      var mx = event.clientX - r.left;
      var my = event.clientY - r.top;
      zoom.s = ZOOM_TIPP;
      zoom.x = mx * (1 - ZOOM_TIPP);
      zoom.y = my * (1 - ZOOM_TIPP);
      inGrenzen();
      anwenden(true);
    });

    function oeffnen(knopf) {
      var quelle = knopf.querySelector('[data-cart-vorschau]');
      if (!quelle) return;

      buehne.innerHTML = '';

      var klon = quelle.cloneNode(true);
      var foto = klon.querySelector('[data-cart-vorschau-foto]');
      var gross = quelle.getAttribute('data-cart-vorschau-gross');

      /* Das Seitenverhaeltnis steht schon fest: Die Zeile zeigt dasselbe Foto,
         nur kleiner, und ihres ist geladen. Damit sitzt der Aufdruck vom
         ersten Bild an richtig, statt nach dem Laden der grossen Fassung
         sichtbar an seinen Platz zu springen. */
      var quellFoto = quelle.querySelector('[data-cart-vorschau-foto]');
      if (quellFoto && quellFoto.naturalWidth && quellFoto.naturalHeight) {
        buehne.dataset.fotoBreite = quellFoto.naturalWidth;
        buehne.dataset.fotoHoehe = quellFoto.naturalHeight;
      } else {
        delete buehne.dataset.fotoBreite;
        delete buehne.dataset.fotoHoehe;
      }

      // In der Zeile reicht ein 400er Bild, hier nicht.
      if (foto && gross) {
        foto.src = gross;
        foto.removeAttribute('srcset');
        foto.removeAttribute('loading');
        foto.removeAttribute('width');
        foto.removeAttribute('height');
      }

      /* Der Klon kommt in einen schlichten Rahmen, und gezoomt wird DER.
         Direkt am Klon ließ sich die Breite nicht ändern — selbst ein
         erzwungenes width blieb wirkungslos, während ein frisch erzeugtes
         Element im selben Kasten sofort gehorchte. Statt der Ursache
         nachzujagen, trägt der Rahmen die Breite und der Klon füllt ihn zu
         100 %. Das Ergebnis ist dasselbe und hängt an keiner Eigenheit. */
      var zoomRahmen = document.createElement('div');
      zoomRahmen.className = 'vorschau-gross__zoombar';
      zoomRahmen.appendChild(klon);
      buehne.appendChild(zoomRahmen);

      var text = klon.querySelector('[data-cart-vorschau-text]');
      zeile.textContent = text && !text.hidden ? text.textContent : '';

      einblendungOeffnen(schicht, knopf);

      skalieren();
      // Vor dem Laden des großen Bildes steht die Breite noch nicht fest.
      if (foto && !foto.complete) foto.addEventListener('load', skalieren, { once: true });
    }

    document.addEventListener('click', function (event) {
      var knopf = event.target.closest('[data-vorschau-oeffnen]');
      if (!knopf) return;
      event.preventDefault();
      oeffnen(knopf);
    });

    window.addEventListener('resize', skalieren);
  }

  /* ------------------------------------------------ Produktbeschreibung */

  /* Die Beschreibung steht hinter einem ⓘ neben dem Titel statt offen auf der
     Seite. Grund: Der Verkehr kommt aus Anzeigen und kauft aus dem Impuls; der
     Kaufknopf liegt auf dem Handy ohnehin schon 2,26 Bildschirme unter der
     Kante. Vier Absätze Fließtext hätten ihn noch weiter nach unten geschoben.

     So bleibt der Text für die erreichbar, die ihn wollen, und kostet die
     übrigen keinen einzigen Pixel. */
  function initBeschreibung() {
    var schicht = document.querySelector('[data-beschreibung]');
    if (!schicht) return;

    document.addEventListener('click', function (event) {
      var knopf = event.target.closest('[data-beschreibung-oeffnen]');
      if (!knopf) return;
      event.preventDefault();
      einblendungOeffnen(schicht, knopf);
    });
  }

  /* ------------------------------------------------ Mitlaufende Kaufleiste */

  /* Die Leiste unten auf dem Handy hat bewusst KEINEN eigenen Weg in den
     Warenkorb oder zur Kasse. Sie klickt den echten Knopf an, damit alles
     greift, was daran hängt: der Variantenabgleich, die Aufdruck-Felder aus
     personalizer.js, die Aufpreiszeile, die Meldung. Ein zweiter Absendeweg
     wäre genau die Stelle, an der ein bedruckter Cardholder ohne seine
     Aufdruck-Daten rausgeht — dieser Fehler ist in diesem Shop schon einmal
     passiert und hat 2,99 € für einen leeren Cardholder gekostet. */
  function initBuyBar() {
    var bar = document.querySelector('[data-buy-bar]');
    if (!bar) return;

    // Auf der Produktseite der Kaufknopf, im Warenkorb der Absendeknopf.
    var ziel = document.querySelector('[data-add-button]')
      || document.querySelector('form[action*="/cart"] [name="checkout"]');
    if (!ziel) return;

    var knopf = bar.querySelector('[data-buy-bar-add], [data-buy-bar-checkout]');
    var preis = bar.querySelector('[data-buy-bar-price]');
    var quellePreis = document.querySelector('.product__price');

    /* Zwei Dinge duerfen die Leiste ueberstimmen, auch wenn der echte
       Kaufknopf ausserhalb des Bildes liegt. Beide sind am Handy gemessen
       worden, beide kosteten Umsatz.

       1. DAS EINWILLIGUNGSBANNER. Shopify legt es als position: fixed mit
          z-index 2000000 ueber die Seite; die Leiste hat 60. Gemessen bei
          375 x 812: Banner y 311 bis 812, darin der Knopf
          "Einstellungen verwalten" bei y 745 bis 780 — die Leiste sitzt bei
          y 743 bis 812. Sie liegen im selben Band, und
          document.elementFromPoint auf die Mitte des Kaufknopfs lieferte
          nicht ihn, sondern den Banner-Knopf. Ein Kunde aus der Anzeige
          tippt also auf "In den Warenkorb" und oeffnet die
          Cookie-Einstellungen. Nichts landet im Korb, nichts erklaert es ihm.
          Die Leiste bleibt deshalb weg, solange der Banner steht.
          NICHT ueber ein hoeheres z-index geloest: dann verdeckt die Leiste
          den Banner, und der Kunde kaeme aus der Einwilligung nicht heraus.

       2. DAS TASTENFELD. Auf iOS bleibt position: fixed am LAYOUT-Fenster
          haengen, nicht am sichtbaren. Sobald das Tastenfeld aufgeht,
          schwebt die Leiste mitten im Bild und verdeckt genau das Feld, in
          das der Kunde gerade seinen Namen tippt. Solange ein Feld des
          Konfigurators den Fokus hat, tritt die Leiste zurueck. */
    function bannerSteht() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(b).visibility !== 'hidden';
    }

    function wirdGetippt() {
      var a = document.activeElement;
      if (!a) return false;
      if (a.tagName !== 'INPUT' && a.tagName !== 'TEXTAREA') return false;
      return !!(a.closest && a.closest('[data-pz-config], .pz, .product__form'));
    }

    /* Ob der echte Kaufknopf im Bild steht, wird GEMESSEN statt gemerkt.

       Vorher hing das an einem Merker, den nur der IntersectionObserver
       setzte. Beim Nachmessen im eingebetteten Browser kam heraus, dass der
       Beobachter dort ueberhaupt nicht antwortet — dieselbe Grenze wie bei
       requestAnimationFrame in einem verborgenen Fenster. Der Merker blieb
       damit auf false, und die Leiste kam nach dem Wegklicken der Einwilligung
       nie zurueck. Auf einem echten Geraet waere das vermutlich nicht
       aufgetreten; "vermutlich" ist bei einem Kaufknopf aber zu wenig.

       Jetzt ist der Beobachter nur noch ein billiger Ausloeser, keine
       Voraussetzung: Gerechnet wird aus dem Rechteck selbst. */
    function zielImBild() {
      var r = ziel.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight - 20);
    }

    /* -------------------------------------------------------------------
       3. BEDIENELEMENTE DER KAUFSPALTE UNTER DER LEISTE

       Die Leiste ist ein geschlossenes Feld ueber ihrer ganzen Hoehe und nimmt
       JEDEN Tipp entgegen, der dort landet — auch den, der einem Bedienelement
       darunter galt. Gemessen am 03.09.2026 bei 375 x 812 auf der
       Anzeigen-Landeseite des MagSafe, Scrollstand 0, ohne Banner:

         Kaufleiste      y 743-812   (69 px hoch)
         Farbfeld Weiss  y 733-777   34 von 44 px verdeckt
         elementFromPoint(98, 755) -> buy-bar__button, nicht das Farbfeld

       Ein Tipp auf "Weiss" legte damit einen SCHWARZEN Cardholder fuer 37,98 EUR
       in den Warenkorb, waehrend der Farbwaehler weiter auf Schwarz stand. Bei
       bedruckter Ware ist der Widerruf nach § 312g Abs. 2 Nr. 1 BGB
       ausgeschlossen — die falsche Ware ist also nicht stornierbar, sondern ein
       Verlust. Bei 390 x 844 waren es noch 17 von 44 px, bei 430 x 932 sauber.

       Deshalb tritt die Leiste zurueck, solange eines dieser Elemente in ihrem
       Band steht. Der Preis dafuer ist bekannt und gewollt: Sie fehlt auf einem
       Teil des Scrollwegs durch die Kaufspalte. Ein verdeckter Knopf, der
       stillschweigend das falsche Produkt bestellt, ist schlimmer als ein
       Knopf, der ein Stueck weit nicht da ist.
       ------------------------------------------------------------------- */

    /* GEAENDERT AM 10.09.2026 ABENDS, auf Wunsch des Inhabers: „ab 200 px,
       aber Konfigurator geschuetzt".

       VORHER wurde gegen den Gesamtbereich ALLER Bedienelemente gerechnet —
       Farbfelder, Namensfeld, Schriftkacheln, Mengenknoepfe. Der spannt fast
       die ganze Kaufspalte, und die Leiste kam deshalb erst bei Scrollstand
       1665. Der Inhaber will sie ab 200 px.

       DIE BEIDEN GRUENDE VON DAMALS BLEIBEN GUELTIG und stehen hier, damit
       niemand sie ein zweites Mal lernen muss:

       1. Elementweise gemessen (375 x 812, MagSafe, 03.09.2026) wechselte die
          Leiste auf den ersten 460 px des Scrollwegs SECHS Mal ihren Zustand —
          die Luecken zwischen den Farbfeldern, dem Zuruecksetzen-Knopf und der
          Vorschau sind kleiner, als die Leiste hoch ist. Bei 0,26 s Uebergang
          je Wechsel zappelt sie ueber die halbe Bildschirmhoehe.
       2. Die Leiste hat Farbfelder VERSCHLUCKT. elementFromPoint auf die Mitte
          eines Farbfelds lieferte buy-bar__button — bestellt wurde schwarze
          statt weisser Ware.

       DIE LOESUNG FUER BEIDES IST EIN EINZIGER KASTEN: gerechnet wird gegen das
       Rechteck des KONFIGURATORS als Ganzem, nicht gegen seine Teile. Ein
       zusammenhaengender Kasten kann sein Band nur EINMAL betreten und einmal
       verlassen — kein Zappeln. Und solange irgendein Teil des Konfigurators im
       Band der Leiste steht, ist die Leiste weg, also kann sie dort auch nichts
       verschlucken.

       Die Mengenknoepfe und der echte Kaufknopf brauchen keinen eigenen Schutz:
       Sie stehen unmittelbar beim Kaufknopf, und zielImBild() haelt die Leiste
       fern, solange der im Bild ist. */
    /* Die eigene Hoehe EINMAL messen, nicht bei jeder Bewertung.

       Wichtig: Sie darf nicht aus dem Rechteck der Leiste kommen, solange die
       Leiste versteckt ist — dann waere das Rechteck leer, das Band haette die
       Hoehe null, kein Element laege darin, die Leiste kaeme zurueck, das Band
       waere wieder da, und sie flackerte im Bildtakt. Gemessen wird deshalb
       einmal beim Start: hidden aus, messen, hidden wieder an. Sichtbar wird
       dabei nichts, weil das CSS sie ueber transform: translateY(105%) aus dem
       Bild haelt, solange .is-visible fehlt.

       WIEDER EINGESETZT AM 10.09.2026: Beim Umbau auf konfiguratorImBand()
       wurde dieser Block versehentlich mit dem alten Bedienelement-Abschnitt
       zusammen entfernt. Folge: konfiguratorImBand() warf
       "eigeneHoehe is not defined", damit warf neuBewerten() bei jedem
       Scrollen, und die Leiste erschien NIE — 187 Ausnahmen in der Konsole.
       Gefunden erst beim echten Scrolltest in Chrome; gerechnet und im
       verborgenen Browser war davon nichts zu sehen. */
    var eigeneHoehe = 0;
    (function hoeheMessen() {
      var warVersteckt = bar.hidden;
      if (warVersteckt) bar.hidden = false;
      eigeneHoehe = Math.round(bar.getBoundingClientRect().height);
      if (warVersteckt) bar.hidden = true;
      if (!eigeneHoehe) eigeneHoehe = 76; // Ausweichwert wie im CSS
    })();

    var MINDESTSCROLL = 200;

    function scrolltiefe() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function konfiguratorImBand() {
      if (!eigeneHoehe) return false;

      var pz = document.querySelector('[data-pz]');
      if (!pz) return false;

      var r = pz.getBoundingClientRect();
      if (!r.width || !r.height) return false;

      // Ein wenig Zugabe, sobald die Leiste schon weg ist: sonst schnappt sie
      // genau an der Grenze im Bildtakt auf und zu.
      var zugabe = bar.classList.contains('is-visible') ? 0 : 12;
      var bandOben = window.innerHeight - eigeneHoehe - zugabe;

      return r.bottom > bandOben && r.top < window.innerHeight;
    }

    function neuBewerten() {
      zeigen(scrolltiefe() >= MINDESTSCROLL &&
             !zielImBild() && !bannerSteht() && !wirdGetippt() &&
             !konfiguratorImBand());
    }

    function zeigen(an) {
      if (an) bar.hidden = false;
      // Ein Bild abwarten, sonst fährt die Leiste nicht ein, sondern springt:
      // hidden und transform in derselben Bildberechnung sieht der Browser
      // nicht als Übergang.
      window.requestAnimationFrame(function () {
        bar.classList.toggle('is-visible', an);
        document.body.classList.toggle('has-buy-bar', an);

        /* Die eigene Höhe weiterreichen, statt sie im CSS zu raten. Zwei
           Dinge hängen daran: der Platz, den die Seite unten anhängt, damit
           die Fußzeile erreichbar bleibt, und die Meldung "Zum Warenkorb
           hinzugefügt", die sonst genau auf dem Knopf landet. Auf dem Handy
           ist die Leiste rund 69 px hoch, am Schreibtisch flacher. */
        if (an) {
          var hoehe = Math.round(bar.getBoundingClientRect().height);
          if (hoehe) document.body.style.setProperty('--buy-bar-h', hoehe + 'px');
        }
        if (!an) {
          window.setTimeout(function () {
            if (!bar.classList.contains('is-visible')) bar.hidden = true;
          }, 300);
        }
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function () { neuBewerten(); });
      }, { rootMargin: '0px 0px -20px 0px' }).observe(ziel);

      // Der Banner kommt und geht per JavaScript, ohne Ereignis. Also
      // beobachten statt fragen — verschwindet er, faehrt die Leiste ein.
      if ('MutationObserver' in window) {
        new MutationObserver(neuBewerten).observe(document.body, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['style', 'class', 'hidden']
        });
      }
      /* Scrollen als zweiter, unabhaengiger Ausloeser — gedrosselt ueber ein
         Bild, damit er den Scrollweg nicht belastet. Die frueher gemessenen
         0,005 ms je Ereignis bleiben damit die Groessenordnung. */
      var wartet = false;
      window.addEventListener('scroll', function () {
        if (wartet) return;
        wartet = true;
        window.requestAnimationFrame(function () { wartet = false; neuBewerten(); });
      }, { passive: true });

      document.addEventListener('focusin', neuBewerten);
      document.addEventListener('focusout', function () {
        // Ein Lidschlag Abstand: zwischen focusout und focusin steht
        // activeElement kurz auf body, sonst blitzt die Leiste auf.
        window.setTimeout(neuBewerten, 60);
      });

      /* KEIN Nachfuehren ueber window.visualViewport.

         Der Gedanke war, die Leiste bei geoeffnetem Tastenfeld am SICHTBAREN
         Fenster auszurichten, weil position: fixed auf iOS am Layout-Fenster
         haengt. Gebaut war es auch — und beim Nachmessen ergab die Formel
         715 px Verschiebung, was die Leiste aus dem Bild geschoben haette. Die
         Ursache lag am Messfenster, nicht an der Formel; nachweisen liess sie
         sich dort aber nicht.

         Auf dem Kaufweg wird nichts ausgeliefert, was sich nicht pruefen
         laesst: Ein falscher Wert verschiebt genau den Knopf, um den es geht.
         Der Fall aus dem Screenshot — die Leiste verdeckt beim Tippen das
         Namensfeld — ist ohnehin schon geloest, weil sie zurueckttritt, solange
         ein Feld des Konfigurators den Fokus hat. Das ist die verlaessliche
         Haelfte, und sie genuegt.

         Wer es spaeter doch nachfuehren will, braucht ein echtes Geraet zum
         Gegenmessen. */

    } else {
      // Ohne Beobachter bleibt die Leiste einfach stehen. Lieber dauerhaft
      // sichtbar als gar kein erreichbarer Knopf.
      zeigen(true);
    }

    if (knopf) {
      knopf.addEventListener('click', function () {
        if (ziel.getAttribute('aria-disabled') === 'true' || ziel.disabled) return;
        ziel.click();
      });
    }

    /* Die Variante wandert mit. Der Titel („Schwarz / Mit Aufdruck") enthaelt
       genau das, was die Leiste braucht: Farbe und ob bedruckt wird.

       NICHT NUR AUS DEM EREIGNIS. Beim Messen am 10.09.2026 stand in der Leiste
       „Schwarz / Ohne Aufdruck" neben dem Preis 37,98 EUR — also die guenstige
       Variante neben dem teuren Preis. Ursache ist die Reihenfolge: Stellt
       personalizer.js beim Laden einen gemerkten Namen wieder her, meldet
       initVariants die Variante EINMAL, bevor diese Leiste ihren Zuhoerer
       angemeldet hat. Diese erste Meldung ist damit verloren, und im Markup
       steht noch der serverseitige Titel.

       Deshalb wird der Wert zusaetzlich direkt gelesen: aus der Variantennummer
       im Kaufformular und der Variantenliste, die der Variantenwaehler ohnehin
       als JSON mitbringt. Das ist von jeder Reihenfolge unabhaengig. */
    var variantenFeld = bar.querySelector('[data-buy-bar-variant]');
    if (variantenFeld) {
      var variantenAbschreiben = function () {
        var idFeld = document.querySelector('[data-product-form] input[name="id"]');
        var quelle = document.querySelector('[data-variant-json]');
        if (!idFeld || !quelle) return;
        try {
          var liste = JSON.parse(quelle.textContent) || [];
          for (var i = 0; i < liste.length; i++) {
            if (String(liste[i].id) === String(idFeld.value)) {
              if (liste[i].title) variantenFeld.textContent = liste[i].title;
              return;
            }
          }
        } catch (fehler) { /* dann bleibt der Titel aus dem Markup stehen */ }
      };

      document.addEventListener('pensum:variant', function (event) {
        var variante = event.detail && event.detail.variant;
        if (variante && variante.title) {
          variantenFeld.textContent = variante.title;
        } else {
          variantenAbschreiben();
        }
      });

      /* Einmal gleich beim Binden — und ein zweites Mal, nachdem die anderen
         Bausteine gelaufen sind. Ohne den zweiten Griff bliebe der Fall offen,
         dass initVariants erst nach dieser Zeile bindet. */
      variantenAbschreiben();
      window.setTimeout(variantenAbschreiben, 0);
    }

    // Den Preis nicht selbst ausrechnen, sondern von der Seite abschreiben.
    // initVariants tauscht .product__price bei jedem Wechsel aus; wer hier
    // eine zweite Rechnung führt, zeigt früher oder später etwas anderes an
    // als der Knopf darüber.
    if (preis && quellePreis && 'MutationObserver' in window) {
      var abschreiben = function () {
        var text = quellePreis.textContent.replace(/\s+/g, ' ').trim();
        if (text) preis.textContent = text.split(' ')[0];
      };
      abschreiben();
      new MutationObserver(abschreiben).observe(quellePreis, {
        childList: true, subtree: true, characterData: true
      });
    }
  }

  /* ------------------------------------------ Kopfbereich über dem Hero

     Beginnt eine Seite mit einem Hero, legt sich der Kopfbereich durchsichtig
     darüber und färbt sich erst beim Scrollen weiß. Auf allen anderen Seiten
     bleibt alles, wie es war — deshalb wird hier geprüft und nicht pauschal
     eine Klasse gesetzt.

     Geprüft wird auf ein Hero MIT Medien: Ohne Bild wäre der Hintergrund die
     Papierfarbe, und ein durchsichtiger Kopf über einer weißen Fläche sähe
     nur nach einem fehlenden Rahmen aus. */
  function initKopfUeberHero() {
    var kopf = document.querySelector('.header');
    var haupt = document.getElementById('MainContent');
    if (!kopf || !haupt) return;

    var ersterAbschnitt = haupt.querySelector('.shopify-section');
    var hero = ersterAbschnitt && ersterAbschnitt.querySelector('.hero');
    if (!hero || !hero.querySelector('.hero__media')) return;

    kopf.classList.add('header--ueber-hero');

    // Ab 24 px gilt als gescrollt — früh genug, dass der Wechsel zur Bewegung
    // gehört, spät genug, dass ein Wackeln am Anfang ihn nicht auslöst.
    var SCHWELLE = 24;
    var angefordert = false;

    function pruefen() {
      angefordert = false;
      kopf.classList.toggle('is-gescrollt', window.scrollY > SCHWELLE);
    }

    /* Über requestAnimationFrame gebündelt: Ein Scroll-Ereignis feuert auf
       dem Handy vielfach je Bild, und jedes Umschalten einer Klasse zwingt
       den Browser zum Nachrechnen. */
    window.addEventListener('scroll', function () {
      if (angefordert) return;
      angefordert = true;
      window.requestAnimationFrame(pruefen);
    }, { passive: true });

    pruefen();
  }

  function boot() {
    initReveal(document);
    initToast();
    initDrawer();
    initSearch();
    initQuantity();
    initGallery(document);
    initVariants(document);
    initProductForms();
    initCartPage();
    initEinblendungen();
    initVorschauGross();
    initBeschreibung();
    initBuyBar();
    initKopfUeberHero();
    initSort();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
    initGallery(event.target);
    initVariants(event.target);
  });
})();
